import commonEn from "./locales/en/common.json";
import navigationEn from "./locales/en/navigation.json";
import loginEn from "./locales/en/auth/login.json";
import ordersOverviewEn from "./locales/en/orders/orders-overview.json";
import orderListEn from "./locales/en/orders/order-list.json";
import orderDetailEn from "./locales/en/orders/order-detail.json";
import orderLifecycleEn from "./locales/en/orders/order-lifecycle.json";
import orderDialogsEn from "./locales/en/orders/order-dialogs.json";
import taskListEn from "./locales/en/tasks/task-list.json";
import taskDetailEn from "./locales/en/tasks/task-detail.json";
import loanListEn from "./locales/en/loans/loan-list.json";
import loanDetailEn from "./locales/en/loans/loan-detail.json";
import clientsEn from "./locales/en/catalog/clients.json";
import vendorsEn from "./locales/en/catalog/vendors.json";

function deepMerge(...objects: any[]): any {
  const result: any = {};

  for (const obj of objects) {
    for (const key in obj) {
      if (Object.hasOwn(obj, key)) {
        const value = obj[key];
        if (value && typeof value === "object" && !Array.isArray(value)) {
          result[key] = deepMerge(result[key] || {}, value);
        } else {
          result[key] = value;
        }
      }
    }
  }

  return result;
}

const en = deepMerge(
  commonEn,
  navigationEn,
  loginEn,
  ordersOverviewEn,
  orderListEn,
  orderDetailEn,
  orderLifecycleEn,
  orderDialogsEn,
  taskListEn,
  taskDetailEn,
  loanListEn,
  loanDetailEn,
  clientsEn,
  vendorsEn,
);

export const translations = en;
